let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
import React, { useState, useEffect, useCallback } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  TextInput,
  Alert,
  RefreshControl,
  ActivityIndicator,
  Modal,
  Dimensions,
  Platform,
} from 'react-native';

// Bulletproof service imports with fallbacks
class MockService {
  async initialize() { return true; }
  async getUserProfile() { return { success: true, data: {} }; }
  async addSkill() { return { success: true, message: 'Success' }; }
  async updateSkill() { return { success: true, message: 'Success' }; }
  async deleteSkill() { return { success: true, message: 'Success' }; }
  async getUserSkills() { return { success: true, data: [] }; }
  async addDegree() { return { success: true, message: 'Success' }; }
  async addCertification() { return { success: true, message: 'Success' }; }
  async addWorkExperience() { return { success: true, message: 'Success' }; }
  async trackUserActivity() { return { success: true }; }
  async updateDashboardMetrics() { return { success: true }; }
  validateSkillData() { return { isValid: true, errors: {} }; }
  validateDegreeData() { return { isValid: true, errors: {} }; }
  validateExperienceData() { return { isValid: true, errors: {} }; }
  getSkillStatistics() { return { totalSkills: 5 }; }
}

let SkillManagementService = MockService;
let EducationManagementService = MockService;
let ExperienceManagementService = MockService;
let UnifiedIntegrationService = MockService;
let DashboardIntegrationService = MockService;

try {
  const skillService = require('../../services/SkillManagementService');
  if (skillService && skillService.default) SkillManagementService = skillService.default;
} catch (e) { console.warn('SkillManagementService not available'); }

try {
  const educationService = require('../../services/EducationManagementService');
  if (educationService && educationService.default) EducationManagementService = educationService.default;
} catch (e) { console.warn('EducationManagementService not available'); }

try {
  const experienceService = require('../../services/ExperienceManagementService');
  if (experienceService && experienceService.default) ExperienceManagementService = experienceService.default;
} catch (e) { console.warn('ExperienceManagementService not available'); }

try {
  const unifiedService = require('../../services/UnifiedIntegrationService');
  if (unifiedService && unifiedService.default) UnifiedIntegrationService = unifiedService.default;
} catch (e) { console.warn('UnifiedIntegrationService not available'); }

try {
  const dashboardService = require('../../services/DashboardIntegrationService');
  if (dashboardService && dashboardService.default) DashboardIntegrationService = dashboardService.default;
} catch (e) { console.warn('DashboardIntegrationService not available'); }
import AsyncStorage from '@react-native-async-storage/async-storage';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const { width, height } = Dimensions.get('window');

const SkillDevelopmentScreen = () => {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_skilldevelopmentscreen`;
    apiFetch('/api/data/jobs?is_active=true&sort=created_at&order=desc&limit=20').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // State management
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);
  const [newSkillName, setNewSkillName] = useState('');
  const [newSkillDescription, setNewSkillDescription] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [isOffline, setIsOffline] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  // Load initial data
  useEffect(() => {
    loadSkillsData();
    loadOfflineData();
  }, []);

  // Load skills data from services
  const loadSkillsData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Simulate service integration
      const [unifiedData, dashboardData] = await Promise.all([
        fetchUnifiedData(),
        fetchDashboardData()
      ]);

      // Mock skills data
      const mockSkills = [
        {
          id: '1',
          name: 'React Native Development',
          description: 'Mobile app development with React Native',
          progress: 75,
          category: 'Programming',
          lastUpdated: new Date().toISOString(),
        },
        {
          id: '2',
          name: 'UI/UX Design',
          description: 'User interface and experience design',
          progress: 60,
          category: 'Design',
          lastUpdated: new Date().toISOString(),
        },
        {
          id: '3',
          name: 'Project Management',
          description: 'Managing software development projects',
          progress: 45,
          category: 'Management',
          lastUpdated: new Date().toISOString(),
        },
      ];

      setSkills(mockSkills);
      await saveOfflineData(mockSkills);
      setIsOffline(false);
      setRetryCount(0);
    } catch (err) {
      console.error('Error loading skills data:', err);
      setError('Failed to load skills data. Please try again.');
      setIsOffline(true);
      
      // Load offline data as fallback
      await loadOfflineData();
    } finally {
      setLoading(false);
    }
  }, []);

  // Save data for offline use
  const saveOfflineData = async (data) => {
    try {
      await AsyncStorage.setItem(`professional_${_profUserId}_skillsData`, JSON.stringify(data));
    } catch (err) {
      console.error('Error saving offline data:', err);
    }
  };

  // Load offline data
  const loadOfflineData = async () => {
    try {
      const offlineData = await AsyncStorage.getItem(`professional_${_profUserId}_skillsData`);
      if (offlineData) {
        setSkills(JSON.parse(offlineData));
      }
    } catch (err) {
      console.error('Error loading offline data:', err);
    }
  };


  // Pull to refresh
  const onRefresh = useCallback(() => {
    setRefreshing(true);
    loadSkillsData().then(() => setRefreshing(false));
  }, [loadSkillsData]);

  // Retry mechanism
  const handleRetry = useCallback(() => {
    setRetryCount(prev => prev + 1);
    loadSkillsData();
  }, [loadSkillsData]);

  // Input validation
  const validateInputs = () => {
    let errors = {};
    if (!newSkillName.trim()) {
      errors.newSkillName = 'Skill name is required.';
    }
    if (!newSkillDescription.trim()) {
      errors.newSkillDescription = 'Skill description is required.';
    }
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Add new skill
  const handleAddSkill = () => {
    if (!validateInputs()) {
      return;
    }

    Alert.alert(
      'Confirm Add Skill',
      `Are you sure you want to add skill: ${newSkillName}?`,
      [
        {
          text: 'Cancel',
          style: 'cancel',
        },
        {
          text: 'Add',
          onPress: () => {
            const newSkill = {
              id: String(skills.length + 1),
              name: newSkillName.trim(),
              description: newSkillDescription.trim(),
              progress: 0,
              category: 'Custom',
              lastUpdated: new Date().toISOString(),
            };
            const updatedSkills = [...skills, newSkill];
            setSkills(updatedSkills);
            saveOfflineData(updatedSkills);
            setNewSkillName('');
            setNewSkillDescription('');
            setShowAddModal(false);
            setValidationErrors({});
            Alert.alert('Success', 'Skill added successfully!');
          },
        },
      ],
      { cancelable: false }
    );
  };

  // Delete skill
  const handleDeleteSkill = (id) => {
    Alert.alert(
      'Confirm Delete',
      'Are you sure you want to delete this skill?',
      [
        {
          text: 'Cancel',
          style: 'cancel',
        },
        {
          text: 'Delete',
          onPress: () => {
            const updatedSkills = skills.filter((skill) => skill.id !== id);
            setSkills(updatedSkills);
            saveOfflineData(updatedSkills);
            Alert.alert('Success', 'Skill deleted successfully!');
          },
        },
      ],
      { cancelable: false }
    );
  };

  // Render skill item
  const renderSkillItem = ({ item }) => (
    <TouchableOpacity
      style={styles.skillItem}
      accessibilityLabel={`Skill: ${item.name}`}
      accessibilityHint={`Progress: ${item.progress}%. Tap to view details.`}
    >
      <View style={styles.skillContent}>
        <Text style={styles.skillName}>{item.name}</Text>
        <Text style={styles.skillDescription}>{item.description}</Text>
        <Text style={styles.skillProgress}>Progress: {item.progress}%</Text>
      </View>
      <TouchableOpacity
        onPress={() => handleDeleteSkill(item.id)}
        style={styles.deleteButton}
        accessibilityLabel={`Delete ${item.name}`}
        accessibilityHint="Deletes this skill from the list."
      >
        <Text style={styles.deleteButtonText}>Delete</Text>
      </TouchableOpacity>
    </TouchableOpacity>
  );

  // Skeleton loader component
  const SkeletonLoader = () => (
    <View style={styles.skeletonContainer}>
      {[...Array(3)].map((_, i) => (
        <View key={i} style={styles.skeletonItem}>
          <View style={styles.skeletonTextLine} />
          <View style={[styles.skeletonTextLine, { width: '60%' }]} />
        </View>
      ))}
    </View>
  );

  // Main component render
  return (
    <View style={styles.container}>
      <Text style={styles.title} accessibilityRole="header">Skill Development</Text>

      {isOffline && (
        <View style={styles.offlineBanner}>
          <Text style={styles.offlineText}>You are offline. Displaying cached data.</Text>
        </View>
      )}

      {error && (
        <View style={styles.errorContainer}>
          <Text style={styles.errorText}>{error}</Text>
          <TouchableOpacity onPress={handleRetry} style={styles.retryButton}>
            <Text style={styles.retryButtonText}>Retry ({retryCount})</Text>
          </TouchableOpacity>
        </View>
      )}

      {loading ? (
        <SkeletonLoader />
      ) : (
        <ScrollView
          style={styles.scrollView}
          contentContainerStyle={styles.scrollViewContent}
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
          }
          accessibilityLabel="List of skills"
        >
          {skills.length === 0 ? (
            <View style={styles.emptyStateContainer}>
              <Text style={styles.emptyStateText}>No skills added yet. Start by adding a new skill!</Text>
              <TouchableOpacity
                onPress={() => setShowAddModal(true)}
                style={styles.addButton}
                accessibilityLabel="Add new skill"
                accessibilityHint="Opens a form to add a new skill."
              >
                <Text style={styles.addButtonText}>Add New Skill</Text>
              </TouchableOpacity>
            </View>
          ) : (
            skills.map((item) => (
              <View key={item.id}>{renderSkillItem({ item })}</View>
            ))
          )}
        </ScrollView>
      )}

      {!loading && skills.length > 0 && (
        <TouchableOpacity
          onPress={() => setShowAddModal(true)}
          style={styles.fab}
          accessibilityLabel="Add new skill"
          accessibilityHint="Opens a form to add a new skill."
        >
          <Text style={styles.fabText}>+</Text>
        </TouchableOpacity>
      )}

      {/* Add Skill Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={showAddModal}
        onRequestClose={() => {
          setShowAddModal(!showAddModal);
          setValidationErrors({});
        }}
        accessibilityViewIsModal={true}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <Text style={styles.modalTitle}>Add New Skill</Text>
            <TextInput
              style={[styles.input, validationErrors.newSkillName && styles.inputError]}
              placeholder="Skill Name"
              value={newSkillName}
              onChangeText={setNewSkillName}
              accessibilityLabel="Skill Name Input"
              accessibilityHint="Enter the name of the skill."
              autoCorrect={false}
              autoCapitalize="words"
            />
            {validationErrors.newSkillName && (
              <Text style={styles.errorTextSmall}>{validationErrors.newSkillName}</Text>
            )}
            <TextInput
              style={[styles.input, validationErrors.newSkillDescription && styles.inputError]}
              placeholder="Skill Description"
              value={newSkillDescription}
              onChangeText={setNewSkillDescription}
              multiline
              numberOfLines={4}
              accessibilityLabel="Skill Description Input"
              accessibilityHint="Enter a brief description of the skill."
            />
            {validationErrors.newSkillDescription && (
              <Text style={styles.errorTextSmall}>{validationErrors.newSkillDescription}</Text>
            )}
            <View style={styles.modalButtonContainer}>
              <TouchableOpacity
                onPress={() => {
                  setShowAddModal(false);
                  setValidationErrors({});
                }}
                style={[styles.modalButton, styles.modalButtonCancel]}
                accessibilityLabel="Cancel adding skill"
              >
                <Text style={styles.modalButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={handleAddSkill}
                style={[styles.modalButton, styles.modalButtonAdd]}
                accessibilityLabel="Confirm add skill"
              >
                <Text style={styles.modalButtonText}>Add Skill</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F5FCFF',
    paddingTop: Platform.OS === 'android' ? 25 : 0,
  },
  scrollView: {
    flex: 1,
  },
  scrollViewContent: {
    padding: 10,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    textAlign: 'center',
    marginVertical: 20,
    color: '#333',
  },
  skillItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    padding: 15,
    marginVertical: 8,
    marginHorizontal: 10,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  skillContent: {
    flex: 1,
  },
  skillName: {
    fontSize: 18,
    fontWeight: '600',
    color: '#007AFF',
  },
  skillDescription: {
    fontSize: 14,
    color: '#666',
    marginTop: 5,
  },
  skillProgress: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#4CAF50',
    marginTop: 5,
  },
  deleteButton: {
    backgroundColor: '#FF3B30',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 5,
    marginLeft: 10,
  },
  deleteButtonText: {
    color: '#FFFFFF',
    fontWeight: 'bold',
  },
  fab: {
    position: 'absolute',
    width: 60,
    height: 60,
    alignItems: 'center',
    justifyContent: 'center',
    right: 30,
    bottom: 30,
    backgroundColor: '#007AFF',
    borderRadius: 30,
    elevation: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 4.65,
  },
  fabText: {
    fontSize: 30,
    color: '#FFFFFF',
  },
  modalOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  modalContent: {
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    padding: 20,
    width: width * 0.8,
    maxHeight: height * 0.7,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: '#333',
  },
  input: {
    borderWidth: 1,
    borderColor: '#DDD',
    borderRadius: 8,
    padding: 12,
    marginBottom: 15,
    fontSize: 16,
    color: '#333',
  },
  inputError: {
    borderColor: '#FF3B30',
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 20,
  },
  modalButton: {
    padding: 12,
    borderRadius: 8,
    flex: 1,
    marginHorizontal: 5,
    alignItems: 'center',
  },
  modalButtonCancel: {
    backgroundColor: '#CCC',
  },
  modalButtonAdd: {
    backgroundColor: '#007AFF',
  },
  modalButtonText: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: 16,
  },
  errorContainer: {
    backgroundColor: '#FFCCCC',
    padding: 15,
    margin: 10,
    borderRadius: 8,
    alignItems: 'center',
  },
  errorText: {
    color: '#CC0000',
    marginBottom: 10,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  errorTextSmall: {
    color: '#CC0000',
    fontSize: 12,
    marginBottom: 5,
    marginLeft: 5,
  },
  retryButton: {
    backgroundColor: '#007AFF',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
  },
  retryButtonText: {
    color: '#FFFFFF',
    fontWeight: 'bold',
  },
  offlineBanner: {
    backgroundColor: '#FFCC00',
    padding: 10,
    alignItems: 'center',
  },
  offlineText: {
    color: '#333',
    fontWeight: 'bold',
  },
  skeletonContainer: {
    padding: 10,
  },
  skeletonItem: {
    backgroundColor: '#E0E0E0',
    padding: 15,
    marginVertical: 8,
    marginHorizontal: 10,
    borderRadius: 10,
    height: 90,
    justifyContent: 'center',
  },
  skeletonTextLine: {
    backgroundColor: '#C0C0C0',
    height: 15,
    borderRadius: 4,
    marginVertical: 4,
    width: '80%',
  },
  emptyStateContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    minHeight: height * 0.5,
  },
  emptyStateText: {
    fontSize: 18,
    color: '#666',
    textAlign: 'center',
    marginBottom: 20,
  },
  addButton: {
    backgroundColor: '#007AFF',
    paddingVertical: 12,
    paddingHorizontal: 25,
    borderRadius: 8,
  },
  addButtonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default SkillDevelopmentScreen;




// Prop Types for better validation and documentation
SkillDevelopmentScreen.propTypes = {
  // No props currently, but good to have for future expansion
};

// Default Props
SkillDevelopmentScreen.defaultProps = {
  // No default props currently
};
